import classNames from "classnames";
import type { ReactNode } from "react";
import { forwardRef } from "react";

import "./styles.scss";
import { legacyClassNames } from "@/react/helpers/cssAnchorHelpers";

export interface TableProps {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
  tableClassName?: string;
  variant?: "default" | "no-border" | "squared";
}

/** @deprecated Please use the new Table components at "@circle-react-uikit/TableV2" */
export const Table = forwardRef<HTMLTableElement, TableProps>(
  (
    { children, dataTestId, className, tableClassName, variant = "default" },
    ref,
  ) => (
    <div
      className={classNames(legacyClassNames("react-table"), className)}
      data-testid={dataTestId}
    >
      <div className={legacyClassNames("react-table__container")}>
        <div
          className={legacyClassNames("react-table__wrapper", {
            "react-table__wrapper--no-border": variant === "no-border",
            "react-table__wrapper--squared": variant === "squared",
          })}
        >
          <table
            ref={ref}
            className={classNames(
              legacyClassNames("react-table__table"),
              tableClassName,
            )}
          >
            {children}
          </table>
        </div>
      </div>
    </div>
  ),
);

Table.displayName = "Table";
